import { IApplicationState } from '../types';

export const getAuthStatus = (state: IApplicationState): string =>
  state.authStatus;
